import React from 'react';

const ErrorPage = () => (
  <div style={{
    maxWidth: '500px',
    margin: '60px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '10px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.10)',
    textAlign: 'center'
  }}>
    <h2 style={{ color: '#c0392b', marginBottom: '18px' }}>Oops! Something went wrong.</h2>
    <p style={{ color: '#555', fontSize: '1.1rem' }}>
      An error occurred. Please try again later or contact support.
    </p>
    <a href="/" style={{ color: '#4078c0', textDecoration: 'underline', marginTop: '18px', display: 'inline-block' }}>
      Go back to Home
    </a>
  </div>
);

export default ErrorPage;